import {
  SetDefaultData,
  FetchNotDeliveredReasonRequest,
  UpdateField,
  UpdateNotDeliveredReasonRequest,
} from '../not-delivered-reason.actions'
import { getUpdateNotDeliveredReasonState } from '../not-delivered-reason.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-update-not-delivered-reason',
  templateUrl: './update-not-delivered-reason.component.html',
  styleUrls: ['./update-not-delivered-reason.component.css'],
})
export class UpdateNotDeliveredReasonComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  public id: number
  private state$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'))
    this.store.dispatch<any>(new SetDefaultData('update'))

    this.state$ = this.store
      .pipe(select(getUpdateNotDeliveredReasonState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch<any>(new FetchNotDeliveredReasonRequest(this.id))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'update.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'update',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      text: 'required',
    }
    const validator = new Validator(
      {
        text: data.get('text'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateNotDeliveredReasonRequest(this.id, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, 'update'),
      )
    }
  }
}
